import { render, staticRenderFns } from "./noticecompany.vue?vue&type=template&id=2b8d4874&scoped=true&"
import script from "./noticecompany.vue?vue&type=script&lang=js&"
export * from "./noticecompany.vue?vue&type=script&lang=js&"
import style0 from "./noticecompany.vue?vue&type=style&index=0&id=2b8d4874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d4874",
  null
  
)

export default component.exports